// extracted by mini-css-extract-plugin
export default {"button":"AsttButtonLight_button__b3BCY"};